import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.boundShowNotification = this.handleShowNotification.bind(this);
    window.addEventListener('notification:show', this.boundShowNotification);
  }

  disconnect() {
    window.removeEventListener('notification:show', this.boundShowNotification);
  }

  handleShowNotification(event) {
    const { type, message } = event.detail || {};

    const templateId = type === 'success'
      ? 'notification-success-template'
      : 'notification-error-template';

    this.appendNotification(templateId, message);
  }

  appendNotification(templateId, message) {
    const template = document.getElementById(templateId);
    if (!template) {
      console.error(`Template not found: ${templateId}`);
      return;
    }

    const frame = document.getElementById('notifications');
    if (!frame) {
      console.error('Notifications frame not found');
      return;
    }

    const clone = template.content.cloneNode(true);

    if (message) {
      const messageElement = clone.querySelector('[data-notification-message]');
      if (messageElement) {
        messageElement.textContent = message;
      }
    }

    frame.appendChild(clone);
  }
}
